import React from 'react';
import classnames from 'classnames';

// local dependencies
import { heartBeatPreloader as HeartBeatPreloader } from 'ui/views/generic/heartBeatPreloader';
import { SIZES } from 'constants/common';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
 *
 * // render
 * <WidgetPreloader propName='propValue'/>
 */
export const widgetPreloader = ( props ) => {

    // dynamic class name
    const widgetClassName = classnames( 'ui-widget-preloader', props.className );

    return (
        <div className={ widgetClassName }>
            <HeartBeatPreloader
                className='ui-widget-preloader__preloader'
                size={ props.size }
            />
        </div>
    );
};

// set display name
widgetPreloader.displayName = 'widgetPreloader';

// set default props
widgetPreloader.defaultProps = {
    size: SIZES.LARGE,
};

// prop types
widgetPreloader.propTypes = {};
